import { ThemeColorMap } from "@web-libs/features/branding/theme/infrastructure/theme-service.provider";

export const ColorMap = {
    textColor: "--text-color",
    unobtrusive: "--text-grey",
    dark: "--dark",
    light: "--light",
    lightShade: "--light-shade",
    lightShadier: "--background-grey",
    ...ThemeColorMap
}

export function getCssVar(color: Color | string){
    if(ColorMap[color as Color] === undefined) return color
    return `var(${ColorMap[color as Color]})`
}

export function addOpacityToHex(hex:string, opacity:number){
    // Clamp the opacity between 0 and 1
    if (opacity < 0) opacity = 0;
    if (opacity > 1) opacity = 1;

    // Convert the opacity value to a hex value
    const alpha = Math.round(opacity * 255);
    const alphaHex = alpha.toString(16).padStart(2, '0');

    return hex + alphaHex;
}

export type Color = keyof typeof ColorMap;
